// Widget compositions used by the screen controllers. No DOM or browser layout.
import { Widget, Button, TextInput, Slider, Checkbox, Panel, Well, Window, Grid, List, ScrollView, Tabs, Slot, Bar, RichText, type Child, type WidgetOptions } from './widget';
import { Icon, CanvasImage } from './icons';
export * from './widget';
export * from './icons';
export * from './scale';
export type { UiStyle } from './presets';
import { spriteIcon } from './icons';
import { rowIcon } from './scale';
export function widget(kind: 'input', options: WidgetOptions & { type: 'range' }, ...children: Child[]): Slider;
export function widget(kind: 'input', options: WidgetOptions & { type: 'checkbox' }, ...children: Child[]): Checkbox;
export function widget(kind: 'input', options?: WidgetOptions | null, ...children: Child[]): TextInput;
export function widget(kind: 'raster', options?: WidgetOptions | null, ...children: Child[]): CanvasImage;
export function widget(kind: string, options?: WidgetOptions | null, ...children: Child[]): Widget;
export function widget(kind: string, options: WidgetOptions | null = {}, ...children: Child[]): Widget {
  const o = options ?? {}, names = String(o.class ?? '').split(/\s+/), style = o.style ?? {};
  const has = (n: string) => names.includes(n);
  let w: Widget;
  const icon = /var\(--img-([\w-]+)\)/.exec(style.backgroundImage ?? style.background ?? '')?.[1]
    ?? (has('icon-friends') ? 'friends' : has('icon-ignore') ? 'ignore' : has('icon-settings') ? 'settings' : null);
  if (icon) w = new Icon(`icon_${icon}`, has('chat-icon') || has('close-icon') ? 8 : has('title-icon') ? 12 : 16, 0, o, true);
  else if (kind === 'input' && o.type === 'range') w = new Slider(o);
  else if (kind === 'input' && o.type === 'checkbox') w = new Checkbox(o);
  else if (kind === 'input') w = new TextInput(o);
  else if (kind === 'raster') w = new CanvasImage(o);
  else if (kind === 'form') w = new Widget('form', o);
  else if (kind === 'button') w = new Button(o);
  else if (has('window')) w = new Window(o);
  else if (has('scroll')) w = new ScrollView(o);
  else if (has('grid')) w = new Grid(o);
  else if (has('list')) w = new List(o);
  else if (has('tabs')) w = new Tabs(o);
  else if (has('slot')) w = new Slot(o);
  else if (has('bar')) w = new Bar(o);
  else if (has('panel')) w = new Panel(o);
  else if (has('well')) w = new Well(o);
  else if (kind === 'text') w = new RichText(o);
  else w = new Widget(kind, o);
  if (kind === 'button' && !w.testId) w.testId = String(children.find(c => typeof c === 'string') ?? '').toLowerCase().replace(/\s+/g, '-');
  if (kind === 'input' && !w.testId) w.testId = String(o.name ?? o.placeholder ?? '').toLowerCase().replace(/\s+/g, '-');
  w.append(...children); return w;
}
export function clear(w: Widget): void { w.replaceChildren(); }
export function fill(w: Widget, ...children: Child[]): void { w.replaceChildren(...children); }
export function moneyView(copper: number): Widget {
  const el = new RichText({ class: 'money row' });
  const coins: [string, number, string][] = [['platinum', Math.floor(copper / 1_000_000), '#b9ebf5'], ['gold', Math.floor(copper / 10_000) % 100, '#f5cd50'], ['silver', Math.floor(copper / 100) % 100, '#cdd4de'], ['copper', copper % 100, '#dc9664']];
  const shown = coins.filter(c => c[1] > 0);
  for (const [name, count, color] of shown.length ? shown : [coins[3]]) el.append(widget('text', { style: { color, fontWeight: '500' } }, count.toLocaleString()), spriteIcon(`coin_${name}`, rowIcon()));
  return el;
}
export function formatMoney(copper: number): string {
  const parts: string[] = [], p = Math.floor(copper / 1_000_000), g = Math.floor(copper / 10_000) % 100, s = Math.floor(copper / 100) % 100, c = copper % 100;
  if (p) parts.push(`${p}p`); if (g) parts.push(`${g}g`); if (s) parts.push(`${s}s`); if (c || !parts.length) parts.push(`${c}c`); return parts.join(' ');
}
